import { call, cancel, cancelled, fork, join, put, race, select, take } from "redux-saga/effects"
import actionTypes from "../../actions/actionTypes"
import { AUTH } from "../../constants/state"
import { putError } from "../helpers"


export const nonBlockingActions = [
    {
        put: actionTypes.WP_DATA_GET_REQUEST,
        take:   [actionTypes.WP_DATA_GET_SUCCESS,              actionTypes.WP_DATA_GET_ERROR],
        caps: ['wpDataGet'] 
    },
    {
        put: actionTypes.WP_PAGES_GET_REQUEST,
        take: [actionTypes.WP_PAGES_GET_SUCCESS,               actionTypes.WP_PAGES_GET_ERROR],
        caps: ['wpPagesGet']
    },
    {
        put: actionTypes.WP_SERVICEPAGES_GET_REQUEST,
        take: [actionTypes.WP_SERVICEPAGES_GET_SUCCESS,        actionTypes.WP_SERVICEPAGES_GET_ERROR],
        caps: ['wpServicePagesGet']
    },
    {
        put: actionTypes.WP_MENUITEMS_GET_REQUEST,
        take: [actionTypes.WP_MENUITEMS_GET_SUCCESS,           actionTypes.WP_MENUITEMS_GET_ERROR],
        caps: ['wpMenuItemsGet']
    },
    {
        put: actionTypes.WP_ROUTES_DATA_GET_REQUEST,
        take: [actionTypes.WP_ROUTES_DATA_GET_SUCCESS,         actionTypes.WP_ROUTES_DATA_GET_ERROR],
        caps: ['routesDataGet']
    },
    {
        put:  actionTypes.CLI_DATA_GET_REQUEST,
        take: [actionTypes.CLI_DATA_GET_SUCCESS,               actionTypes.CLI_DATA_GET_ERROR],
        caps: ['cliDataGet']
    },
    {
        put: actionTypes.EVENTS_ALL_REQUEST,
        take: [actionTypes.EVENTS_ALL_SUCCESS,                  actionTypes.EVENTS_ALL_ERROR],
        caps: ['eventDataGet']
    }
]

export const programActions = [
    {
        put: actionTypes.PROGRAM_GET_REQUEST,
        take: [actionTypes.PROGRAM_GET_SUCCESS,                actionTypes.PROGRAM_GET_ERROR],
        caps: ['programDataGet']
    }
]

export const afterProgramActions = [
    {
        put:  actionTypes.MULTISITE_SELECTOR_GET_REQUEST,
        take: [actionTypes.MULTISITE_SELECTOR_FILTER_SUCCESS,  actionTypes.MULTISITE_SELECTOR_GET_ERROR,       actionTypes.MULTISITE_SELECTOR_FILTER_ERROR],
        caps: ['multisiteSelectorDataGet']
    },
    {
        put: actionTypes.NEWSLETTER_GET_CAMPAIGNS_REQUEST,
        take: [actionTypes.NEWSLETTER_GET_CAMPAIGNS_SUCCESS,   actionTypes.NEWSLETTER_GET_CAMPAIGNS_ERROR],
        caps: ['newsletterDataGet']
    },
    {
        put: actionTypes.NEWSLETTER_GET_REQUEST,
        take: [actionTypes.NEWSLETTER_GET_SUCCESS,   actionTypes.NEWSLETTER_GET_ERROR],
        caps: ['newsletterDataGet']
    },
    {
        put: actionTypes.PRINT_DATA_GET_REQUEST,
        take: [actionTypes.PRINT_DATA_GET_SUCCESS,             actionTypes.PRINT_DATA_GET_ERROR],
        caps: ['printDataGet']
    },
    {
        put: actionTypes.PUSH_DATA_GET_REQUEST,
        take: [actionTypes.PUSH_DATA_GET_SUCCESS,             actionTypes.PUSH_DATA_GET_ERROR],
        caps: ['pushDataGet']
    },    
    // {
    //     put:  actionTypes.SIGNAGE_GET_REQUEST,
    //     take: [actionTypes.SIGNAGE_GET_SUCCESS,                actionTypes.SIGNAGE_GET_ERROR],
    //     caps: ['signageDataGet']
    // }
]

export const filterActions = [
    {
        put: actionTypes.NEWSLETTER_FILTER_REQUEST,
        take: [actionTypes.NEWSLETTER_FILTER_SUCCESS, actionTypes.NEWSLETTER_FILTER_ERROR],
        caps: ['newsletterDataGet']
    }
]


const getCaps = state => ({
    caps: state.getIn([AUTH, 'caps']).toJS()
})


function* checkCaps(userCaps, actionCaps) {
    const actionCup = yield actionCaps[0]

    return yield userCaps.hasOwnProperty(actionCup) && userCaps[actionCup]
}


function* loading(a, signal) {
    yield put({
        type: a.put,
        payload: {
            signal: signal
        }
    })

    const { type }  = yield take(a.take)

    if(type && (0 === a.take.indexOf(type))) {
        return true
    } else {
        return false
    }
}

function* filterAction(actionsArray, caps, pending) {
    for (let i = 0; i < actionsArray.length; i++) {
        if(yield call(checkCaps, caps, actionsArray[i].caps)) {
            yield pending.push(yield fork(loading, actionsArray[i], false))
        }
    }
}

function* forkActions(actionsArray, caps, controllers, pending) {
        for (let i = 0; i < actionsArray.length; i++) {
            if(yield call(checkCaps, caps, actionsArray[i].caps)) {
                const controller = yield new AbortController()
                yield controllers.push(controller)
                yield pending.push(yield fork(loading, actionsArray[i], controller.signal))
            }
        }
}

function* callActions(actionsArray, caps, controllers) {
    for (let i = 0; i < actionsArray.length; i++) {
        if(yield call(checkCaps, caps, actionsArray[i].caps)) {
            const controller = yield new AbortController()
            yield controllers.push(controller)
            yield call(loading, actionsArray[i], controller.signal)
        }
    }
}

function* loadAll() {
    const controllers = []
    const pending = [];

    try {
        const { caps } = yield select(getCaps)

        yield fork(forkActions, nonBlockingActions, caps, controllers, pending)
        yield call(callActions, programActions, caps, controllers)
        yield fork(forkActions, afterProgramActions, caps, controllers, pending)
    

        const forkResults = yield join(pending)

        if(-1 !== forkResults.findIndex(r => !r)) {
            throw new Error('Could not load all data')
        }

        const pendingFilters = yield []

        yield fork(filterAction, filterActions, caps, pendingFilters)

        const filterResults = yield join(pendingFilters)

        if(-1 !== filterResults.findIndex(r => !r)) {
            throw new Error('Could not filter all data')
        }

        yield put({type: actionTypes.LOAD_ALL_DATA_SUCCESS})
    } catch(e) {
        yield call(putError, actionTypes.LOAD_ALL_DATA_ERROR, e.message)
    } finally {
        if(yield cancelled()) {
            for(let k = 0; k < controllers.length; k++) {
                controllers[k].abort()
            }

            for(let l = 0; l < pending.length; l++) {
                yield cancel(pending[l])
            }
        }
    }
}

export function* watchLoadAll() {

    while (true) {
        yield take(actionTypes.LOAD_ALL_DATA_REQUEST)
        yield race({
            task: call(loadAll),
            cancel: take([actionTypes.AUTH_FLOW_ERROR])
        })
    }
}